import React from "react";

function Litigation() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Litigation</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              A very wide area which is the mainstream business source for all law firms.  This covers any dispute which reaching court whether it is civil or criminal.  Civil litigation cases include all sorts of dispute and pretty much overlap with all the areas of expertise mentioned above.  The firm has a dedicated team which deals with litigation matters every single working day.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Litigation;
